/* eslint-disable @typescript-eslint/naming-convention */
import { Dispatch } from 'react';
import { creditTiers } from '../common/constants';

export interface AffordamilityState {
  annualIncome: number;
  monthlyDebt: number;
  downPayment: number;
  propertyTaxRate: number;
  hOAFees: number;
  creditScore: CreditTiersType;
  interestRate: number;
  homePrice: number;
  monthlyPayment: number;
  sliderValue: number;
  showFull: boolean;
}

export type CreditTiersType = (typeof creditTiers)[keyof typeof creditTiers];

export enum AffordabilityDataActionsTypes {
  RESET_TO_DEFAULTS,
  SET_ANNUAL_INCOME,
  SET_TOTAL_MONTHLY_DEBT,
  SET_DOWN_PAYMENT,
  SET_PROPERTY_TAX_RATE,
  SET_HOA_FEES,
  SET_CREDIT_SCORE,
  SET_INTEREST_RATE,
  SET_SLIDER_VALUE,
  SET_SHOW_FULL
}

export type AffordabilityDataActions =
  | {
      type: AffordabilityDataActionsTypes.RESET_TO_DEFAULTS;
    }
  | {
      type: AffordabilityDataActionsTypes.SET_ANNUAL_INCOME;
      payload: number;
    }
  | {
      type: AffordabilityDataActionsTypes.SET_TOTAL_MONTHLY_DEBT;
      payload: number;
    }
  | {
      type: AffordabilityDataActionsTypes.SET_DOWN_PAYMENT;
      payload: number;
    }
  | {
      type: AffordabilityDataActionsTypes.SET_PROPERTY_TAX_RATE;
      payload: number;
    }
  | {
      type: AffordabilityDataActionsTypes.SET_HOA_FEES;
      payload: number;
    }
  | {
      type: AffordabilityDataActionsTypes.SET_CREDIT_SCORE;
      payload: CreditTiersType;
    }
  | {
      type: AffordabilityDataActionsTypes.SET_INTEREST_RATE;
      payload: number;
    }
  | {
      type: AffordabilityDataActionsTypes.SET_SLIDER_VALUE;
      payload: number;
    }
  | {
      type: AffordabilityDataActionsTypes.SET_SHOW_FULL;
      payload: boolean;
    };
export type Affordability = 'Affordable' | 'Stretching' | 'Aggressive';
export type CalculatorContextType = {
  state: AffordamilityState;
  dispatch: Dispatch<AffordabilityDataActions>;
  getDownPayment: () => number;
  getDownPaymentPercentage: () => number;
  getAnnualIncome: () => number;
  getMonthlyIncome: () => number;
  getSliderGradient: () => {
    maxStretch: number;
    maxAffordable: number;
  };
  getPresentValue: () => number;
  getHomePrice: () => number;
  getMonthlyPayment: () => number;
  getResultDTISelector: () => number;
  getAffordability: () => Affordability;
  getError: () => string;
};
